export const gridColumns = {
  s: 1,
  m: 2,
  l: 2,
};
